<template>
  <div class="card ml-15 mr-15">
    <div class="card-header">
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <a href="javascript:void(0)">LXD</a>
          </li>
          <li class="breadcrumb-item">
            <a href="javascript:void(0)" @click="$router.push({name: 'lxd'})">List Instances</a>
          </li>
          <li aria-current="page" class="breadcrumb-item active">
            <a href="javascript:void(0)">{{ $route.params.id }}</a>
          </li>
        </ol>
      </nav>
    </div>
    <div class="card-body">
      <div v-if="!showSuccess" class="row">
        <div class="col-md-12 d-flex justify-content-end mb-10 align-items-center">
          <button class="btn btn-primary btn-sm" @click="getInstanceDetails">
            <i class="fa fa-refresh"></i>
            Refresh
          </button>
        </div>
        <div class="col-md-6">
          <div class="card inner-card action">
            <div class="card-header inner-card-header action-header">Actions <i class="fa fa-bolt"></i></div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-3">
                  <button :disabled="details.status && details.status.toLowerCase() === 'running'" class="box-btn"
                          @click="actionHandler('start')">
                    <i v-if="action === 'start'" class="fa fa-spin fa-spinner text-success"></i>
                    <i v-else class="fa fa-play text-success"></i>
                    <span>Start Instance</span>
                  </button>
                </div>
                <div class="col-md-3">
                  <button :disabled="details.status && details.status.toLowerCase() === 'stopped'"
                          class="box-btn" @click="actionHandler('stop')">
                    <i v-if="action === 'stop'" class="fa fa-spin fa-spinner text-danger"></i>
                    <i v-else class="fa fa-stop text-danger"></i>
                    <span>Stop Instance</span>
                  </button>
                </div>
                <div class="col-md-3">
                  <button :disabled="details.status && details.status.toLowerCase() === 'stopped'" class="box-btn"
                          @click="actionHandler('restart')">
                    <i v-if="action === 'restart'" class="fa fa-spin fa-spinner text-primary"></i>
                    <i v-else class="fa fa-refresh text-primary"></i>
                    <span>Restart Instance</span>
                  </button>
                </div>
                <div class="col-md-3">
                  <button class="box-btn" @click="actionHandler('adjustResource')">
                    <i class="fa fa-microchip text-warning"></i>
                    <span>Adjust Resources</span>
                  </button>
                </div>
                <div class="col-md-3">
                  <button class="box-btn" @click="actionHandler('upgrade')">
                    <i class="fa fa-arrow-up text-info"></i>
                    <span>Upgrade Instance</span>
                  </button>
                </div>
                <div v-if="user.userType === 'super-admin'" class="col-md-3">
                  <button class="box-btn" @click="actionHandler('delete')">
                    <i v-if="action === 'delete'" class="fa fa-spin fa-spinner text-danger"></i>
                    <i v-else class="fa fa-trash" style="color: red"></i>
                    <span>Delete Instance</span>
                  </button>
                </div>
                <div class="col-md-3">
                  <button class="box-btn" @click="actionHandler('resize')">
                    <i class="fa fa-expand text-success"></i>
                    <span>Resize Disk</span>
                  </button>
                </div>
              </div>

            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="card inner-card resource">
            <div class="card-header inner-card-header resource-header">Resource Usage</div>
            <div class="card-body" style="height: 420px">
              <div v-if="loading">
                <div class="loader"></div>
              </div>
              <div v-else>
                <div class="info-body">
                  <span>Disk Space</span>
                  <span style="width: 50%">
                  <div v-if="details.resources.disk_usage_percent !== '-'" class="mb-2">
                    <div class="d-flex justify-content-between align-items-center mb-1">
                      <span class="fw-semibold">{{
                          details.resources.disk_usage || '0GB'
                        }} / {{ details.resources.disk || '0GB' }}</span>
                      <span class="fw-semibold">{{ details.resources.disk_usage_percent }}</span>
                    </div>
                    <div class="progress" style="height: 14px; ">
                      <div
                          :aria-valuenow="details.resources.disk_usage_percent"
                          :style="progressBarStyle(details.resources.disk_usage_percent)"
                          aria-valuemax="100"
                          aria-valuemin="0"
                          class="progress-bar bg-success progress-bar-striped"
                          role="progressbar"
                      ></div>
                    </div>
                  </div>
                  <div v-else class="mb-2">
                    <div class="d-flex justify-content-between align-items-center mb-1">
                      <span class="fw-semibold">0GB / {{ details.resources.disk }}</span>
                      <span class="fw-semibold">0%</span>
                    </div>
                    <div class="progress" style="height: 14px; ">
                      <div
                          :aria-valuenow="0"
                          :style="'width: 0%'"
                          aria-valuemax="100"
                          aria-valuemin="0"
                          class="progress-bar bg-success progress-bar-striped"
                          role="progressbar"
                      ></div>
                    </div>
                  </div>
                </span>
                </div>
                <div class="info-body">
                  <span>Memory</span>
                  <span style="width: 50%">
                  <div v-if="!details.resources.memory_usage_percent || details.resources.memory_usage_percent !== '-'"
                       class="mb-2">
                    <div class="d-flex justify-content-between align-items-center mb-1">
                      <span class="fw-semibold">{{ details.resources.memory_usage || '0GB' }} / {{
                          details.resources.ram || '0GB'
                        }}</span>
                      <span class="fw-semibold">{{ details.resources.memory_usage_percent }}</span>
                    </div>
                    <div class="progress" style="height: 14px; ">
                      <div
                          :aria-valuenow="details.resources.memory_usage_percent"
                          :style="progressBarStyle(details.resources.memory_usage_percent)"
                          aria-valuemax="100"
                          aria-valuemin="0"
                          class="progress-bar bg-success progress-bar-striped"
                          role="progressbar"
                      ></div>
                    </div>
                  </div>
                  <div v-else class="mb-2">
                    <div class="d-flex justify-content-between align-items-center mb-1">
                      <span class="fw-semibold">{{ details.resources.memory_usage || '0GB' }} / {{
                          details.resources.ram || '0GB'
                        }}</span>
                      <span class="fw-semibold">0%</span>
                    </div>
                    <div class="progress" style="height: 14px; ">
                      <div
                          :aria-valuenow="0"
                          :style="'width: 0%'"
                          aria-valuemax="100"
                          aria-valuemin="0"
                          class="progress-bar bg-success progress-bar-striped"
                          role="progressbar"
                      ></div>
                    </div>
                  </div>
                </span>
                </div>
                <div class="info-body">
                  <span>CPU</span>
                  <span>{{ details.resources.cpu }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="card inner-card config">
            <div class="card-header inner-card-header font-config">Config</div>
            <div class="card-body">
              <perfect-scrollbar class="scroll-area-config">
                <div v-if="loading">
                  <div class="loader"></div>
                </div>
                <div v-else>
                  <template v-if="details.config">
                    <div v-for="(row, index) in Object.keys(details.config)" :key="index" class="info-body">
                      <span>{{ row }}</span>
                      <span>{{ details.config[row] }}</span>
                    </div>
                  </template>
                  <div v-else class="d-flex justify-content-center align-items-center" style="height: 670px">
                    <span class="text-danger fw-600">No Config exists.</span>
                  </div>
                </div>
              </perfect-scrollbar>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="card inner-card information">
            <div class="card-header inner-card-header bg-info">Information</div>
            <div class="card-body" style="height:  670px">
              <div v-if="loading">
                <div class="loader"></div>
              </div>
              <div v-else>
                <div class="info-body">
                  <span>Status</span>
                  <p :class="details.status.toLowerCase() === 'running' ? 'badge-success' : 'badge-danger'"
                     class="badge badge-pill">{{ details.status }}</p>
                </div>
                <div class="info-body">
                  <span>Created</span>
                  <span>{{ details.created }}</span>
                </div>
                <div class="info-body">
                  <span>Name</span>
                  <span>{{ details.name }}</span>
                </div>
                <div class="info-body">
                  <span>IP Address</span>
                  <span>{{ details.ip_address }}</span>
                </div>
                <div class="info-body">
                  <span>Node</span>
                  <span>{{ details.node }}</span>
                </div>
                <div class="info-body">
                  <span>Architecture</span>
                  <span>{{ details.architecture }}</span>
                </div>
                <div class="info-body">
                  <span>Profiles</span>
                  <span>{{ details.profiles ? details.profiles.toString() : '-' }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div v-if="showSuccess" class="col-md-12">
          <svg class="checkmark" viewBox="0 0 52 52">
            <circle class="checkmark-circle" cx="26" cy="26" fill="none" r="25"/>
            <path class="checkmark-check" d="M14 27l7 7 16-16" fill="none"/>
          </svg>
          <h4 class="text-center fw-600">Instance Deleted Successfully</h4>
          <p class="text-center">
            Press a button below to either create a new instance or view the list of instances.
          </p>
          <div class="d-flex justify-content-center">
            <button class="btn btn-outline-info" @click="openInstanceList('create')">Create New Instance</button>
            <button class="ml-20 btn btn-danger btn-outline-danger"
                    @click="openInstanceList('list')">List Instances
            </button>
          </div>
        </div>
      </div>
    </div>
    <action-modal ref="actionModal" @refresh="getInstanceDetails"/>
  </div>
</template>

<script>
import actionModal from "@/views/admin/Lxd/details/actionModal.vue";
import {PerfectScrollbar} from 'vue2-perfect-scrollbar';
import swal from "sweetalert2";

export default {
  name: "index",
  components: {actionModal, PerfectScrollbar},
  mounted() {
    this.cluster = localStorage.getItem("cluster");
    this.getInstanceDetails()
  },
  data() {
    return {
      cluster: '',
      details: {resources: {}, status: ''},
      loading: false,
      action: '',
      showSuccess: false
    }
  },
  methods: {
    openInstanceList(type) {
      if(type === 'create') {
        this.$router.push({name: 'create-lxd'});
      } else if(type === 'list') {
        this.$router.push({name: 'lxd'});
      }
    },
    async actionHandler(action) {
      try {
        this.action = action;
        if (action === 'start') {
          const resp = await this.$http.post('/lxd/instance/action', {
            grant_type: 'token',
            action,
            cluster: this.cluster,
            name: this.details.name
          })
          console.log('resp', resp.data)
        } else if (action === 'stop') {
          const resp = await this.$http.post('/lxd/instance/action', {
            grant_type: 'token',
            action,
            cluster: this.cluster,
            name: this.details.name
          })
        } else if (action === 'restart') {
          const resp = await this.$http.post('/lxd/instance/action', {
            grant_type: 'token',
            action,
            cluster: this.cluster,
            name: this.details.name
          })
          console.log('resp', resp.data)
        } else if (action === 'delete') {
          swal({
            title: "Are you sure?",
            text: "Are you sure that you want to delete the instance?",
            type: "question",
            confirmButtonText: "Yes Proceed",
            confirmButtonColor: "#6ACF98",
            showCancelButton: true,
            cancelButtonText: "No Thanks",
            cancelButtonColor: "#EE8057"
          }).then(async result => {
            if (result.value) {
              this.action = action
              const resp = await this.$http.post('/lxd/instance/action', {
                grant_type: 'token',
                action,
                cluster: this.cluster,
                name: this.details.name
              })
              console.log('resp', resp.data)
              this.showSuccess = resp.data.success
            }
          })
          return
        } else if (action === 'adjustResource') {
          this.$refs.actionModal.load({
            title: 'Adjust Resource',
            action: 'adjustResource',
            ram: this.details.resources && this.details.resources.ram ? parseFloat(this.details.resources.ram) : 0,
            cpu: this.details.resources && this.details.resources.cpu ? (this.details.resources.cpu) : 0,
            ramUnit: this.details.resources && this.details.resources.ram ? this.details.resources.ram.replace(parseFloat(this.details.resources.ram), '') : 'GB',
            cluster: this.cluster,
            name: this.details.name
          });
          return

        } else if (action === 'upgrade') {
          this.$refs.actionModal.load({
            title: 'Upgrade Instance',
            action: 'upgrade',
            cluster: this.cluster,
            name: this.details.name,
            profile: this.details.profiles && this.details.profiles.length ? this.details.profiles[0] : 'wpo-starter'
          });
          return
        } else if (action === 'resize') {
          this.$refs.actionModal.load({
            title: 'Resize Disk',
            action: 'resize',
            cluster: this.cluster,
            name: this.details.name,
            disk: this.details.resources.disk ? parseFloat(this.details.resources.disk) : 0,
            diskUnit: this.details.resources.disk ? this.details.resources.disk.replace(parseFloat(this.details.resources.disk), '') : 'GB',
          });
          return
        }
        this.getInstanceDetails()
        this.action = ''
      } catch (e) {
        console.log('error occurred', e);
        this.showToast({
          message: `Something went wrong! ${e.toString()}`,
          duration: 2000
        }, true, 'danger')
        this.action = ''
      }
    },
    progressBarStyle(percentage) {
      console.log('progress', percentage);
      if (!percentage || percentage === '-') return
      // Determine color gradient based on percent
      const percent = Number(percentage.split('%')[0]);
      let gradient;
      const gradientColors = [
        '#2ecc40', // Green
        '#a3e635', // Lime
        '#eab308', // Yellow
        '#f97316', // Orange
        '#ef4444', // Red
        '#b91c1c', // Deep Red
        '#7f1d1d'  // Very Deep Red
      ];
      console.log(gradientColors.slice(0, 2).join(','))
      if (percent <= 20) {
        gradient = `linear-gradient(to right, ${gradientColors[0]}, #27ae60)`;
      } else if (percent <= 40) {
        gradient = `linear-gradient(to right, ${gradientColors.slice(0, 2).join(',')})`;
      } else if (percent <= 60) {
        gradient = `linear-gradient(to right, ${gradientColors.slice(0, 3).join(',')})`;
      } else if (percent <= 75) {
        gradient = `linear-gradient(to right, ${gradientColors.slice(0, 4).join(',')})`;
      } else if (percent <= 90) {
        gradient = `linear-gradient(to right, ${gradientColors.slice(0, 5).join(',')}`;
      } else if (percent <= 95) {
        gradient = `linear-gradient(to right, ${gradientColors.slice(0, 6).join(',')})`;
      } else {
        gradient = 'linear-gradient(to right, #a3e635, red)';
      }

      return {
        width: percent + '%',
        background: gradient,
        transition: 'width 0.5s ease, background 0.5s ease'
      };
    },
    convertToMB(value) {
      if (!value) return 0;
      const num = parseFloat(value); // extract numeric part
      if (value.toLowerCase().includes("gb")) {
        return num * 1024; // 1 GB = 1024 MB
      } else if (value.toLowerCase().includes("mb")) {
        return num;
      } else {
        throw new Error("Unknown unit, must be MB or GB");
      }
    },
    async getInstanceDetails() {
      try {
        this.loading = true;
        const name = this.$route.params.id;
        const resp = await this.$http.post('/lxd/get-details', {
          name,
          cluster: localStorage.getItem('cluster') || 'lx4',
          grant_type: 'token'
        })
        console.log('response', resp.data)
        this.details = resp.data.data
        if (this.details.resources) {
          let {disk, disk_usage, disk_usage_percent} = this.details.resources
          console.log('disk_usage', disk_usage_percent)
          if (disk && disk_usage && disk_usage_percent === '-') {
            const usageMB = this.convertToMB(disk_usage);
            const totalMB = this.convertToMB(disk);

            if (totalMB === 0) return 0;
            this.details.resources.disk_usage_percent = `${((usageMB / totalMB) * 100).toFixed(2)}%`;
          }
          let {memory_usage, ram, memory_usage_percent} = this.details.resources;
          if (memory_usage && ram && memory_usage_percent === '-') {
            const usageMB = this.convertToMB(memory_usage);
            const totalMB = this.convertToMB(ram);

            if (totalMB === 0) return 0;
            this.details.resources.memory_usage_percent = `${((usageMB / totalMB) * 100).toFixed(2)}%`;
          }
          console.log('memory_usage_percent', memory_usage_percent)
        }
      } catch (e) {
        console.log('error', e)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.inner-card {
  border: 1px solid #ccc;
}

.inner-card-header {
  //background: lightgrey !important;
  border-top-left-radius: 9px;
  border-top-right-radius: 9px;
  padding: 10px;
}

.information {
  border-left: 5px solid #ff0000;
}

.info-body {
  display: flex;
  justify-content: space-between;
  font-size: 16px;
  margin-bottom: 10px;
}

.config {
  border-left: 5px solid green;
}

.font-config {
  color: green;
  font-weight: bold;
  background: #20940669 !important;
}

.info-body {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  margin-bottom: 8px;
  border: 1px solid #e5e7eb; /* light gray border */
  border-radius: 6px;
  background-color: #f9fafb; /* subtle background */
}

.info-body span:first-child {
  font-weight: 600;
  color: #6b7280; /* gray-600 */
}

.info-body span:last-child {
  font-weight: 600;
  color: #3b82f6; /* light blue */
}

.bg-info {
  background: #da5d5d45 !important;
  color: #ff0000;
  font-weight: bold;
}

.resource-header {
  background: #C7E4EA !important;
  color: cadetblue;
  font-weight: bold;
}

.resource {
  border-left: 5px solid cadetblue;
}

.action-header {
  background: #95520a2b !important;
  color: #95520a;
  font-weight: bold;
}

.action {
  border-left: 5px solid #95520a;
}

.box-btn {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%; /* fixed width */
  height: 180px; /* fixed height */
  padding: 20px;
  background: white;
  color: black;
  border: 1px solid #d1d5db;
  border-radius: 12px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 600;
  gap: 12px; /* space between icon and text */
  transition: all 0.25s ease;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  text-align: center;
  margin-bottom: 20px;
}

.box-btn:disabled {
  background: #80808042 !important;
}

.box-btn i {
  font-size: 28px;
}

.box-btn:hover {
  background: #f9fafb;
  transform: translateY(-3px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.1);
}

.box-btn:active {
  transform: scale(0.97);
}

.scroll-area-config {
  position: relative;
  max-height: 650px !important;
  overflow: hidden;
}
.checkmark {
  width: 100px;
  height: 100px;
  margin: 0 auto;
  stroke-width: 3;
  stroke: #22c55e;
  stroke-miterlimit: 10;
  border-radius: 50%;
  display: block;
}

.checkmark-circle {
  stroke-dasharray: 157;
  stroke-dashoffset: 157;
  stroke: #22c55e;
  animation: circleDraw 0.7s ease-in-out forwards;
}

.checkmark-check {
  stroke-dasharray: 48;
  stroke-dashoffset: 48;
  stroke: #22c55e;
  animation: checkDraw 0.5s ease-in-out forwards;
  animation-delay: 0.7s;
}

@keyframes circleDraw {
  to {
    stroke-dashoffset: 0;
  }
}

@keyframes checkDraw {
  to {
    stroke-dashoffset: 0;
  }
}

@keyframes pop {
  0% {
    transform: scale(0.8);
    opacity: 0;
  }
  60% {
    transform: scale(1.05);
    opacity: 1;
  }
  100% {
    transform: scale(1);
  }
}
</style>